import { eachMonthOfInterval, format, parse } from 'date-fns';
import { TFiltersProps } from '../../components/filters/Filters';

type TCompany = { id: string; name: string };

export const companyFilter = (companies: TCompany[], value: string | undefined, onChange: (value?: string) => void): TFiltersProps['filters'][number] => ({
  disabled: companies.length === 0,
  label: 'Company',
  name: 'companyId',
  onChange: (nextValue) => onChange(nextValue == null ? undefined : String(nextValue)),
  options: companies.map((company) => ({ label: company.name, value: company.id })),
  type: 'singleSelect',
  value
});

export const REPORT_START_MONTH = '2023-04';

export const eventReportEndDate = () => {
  const today = new Date();
  const year = today.getUTCFullYear() + 2;
  const lastDay = new Date(Date.UTC(year, today.getUTCMonth() + 1, 0)).getUTCDate();
  return new Date(Date.UTC(year, today.getUTCMonth(), Math.min(today.getUTCDate(), lastDay))).toISOString().slice(0, 10);
};

export const monthFilter = (value: string, onChange: (value: string) => void, throughMonth = new Date().toISOString().slice(0, 7)): TFiltersProps['filters'][number] => {
  const today = new Date();
  const months = eachMonthOfInterval({ start: parse(REPORT_START_MONTH, 'yyyy-MM', today), end: parse(throughMonth, 'yyyy-MM', today) }).map((month) => format(month, 'yyyy-MM'));

  return {
    includeEmptyOption: false,
    label: 'Month',
    name: 'month',
    onChange: (nextValue) => {
      const month = String(nextValue || '');
      onChange(months.includes(month) ? month : value);
    },
    options: months.map((month) => ({ label: month, value: month })),
    orderDirection: 'desc',
    type: 'singleSelect',
    value
  };
};
